import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19060dad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pt-5 position-fixed top-0 start-0 h-100 w-100",
  style: {"background-color":"rgba(0, 0, 0, 0.25)"}
}
const _hoisted_2 = { class: "card-header h2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "X", -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "card-body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($props.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                id: "backdrop",
                onClick: $setup.backdropClick,
                class: "modal1-dialog h-100 overflow-auto"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card px-0", ($props.container == null) ? 'container' : `container-${$props.container}`]),
                  style: _normalizeStyle(($props.maxwidth != null) ? `max-width: ${$props.maxwidth}` : null)
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString($props.header) + " ", 1 /* TEXT */),
                    ($props.closeable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit("update:modelValue", false))),
                          class: "btn btn-text float-end"
                        }, _hoisted_4))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ])
                ], 6 /* CLASS, STYLE */)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 3 /* FORWARDED */
    })
  ]))
}